import React, { useCallback } from 'react';
import { useCancelTriggerExecution } from '../../../../../../mutations/v1/applicant_tracking/applicationFeed/useCancelTriggeredExecution';
import { ConfirmationModal } from '../../../../../../components/ConfirmationModal';

interface TriggerCancellationModalProps {
  isOpen: boolean;
  candidateName: string;
  feedEntryId: number;
  onClose: () => void;
  onConfirm: () => void;
}

export const TriggerCancellationModal = ({
  isOpen,
  candidateName,
  feedEntryId,
  onClose,
  onConfirm,
}: TriggerCancellationModalProps) => {
  const { handleCancelTrigger } = useCancelTriggerExecution(feedEntryId);

  const handleCancellationConfirm = useCallback(() => {
    const asyncCall = async () => {
      await handleCancelTrigger();
      onConfirm();
    };

    asyncCall();
  }, [handleCancelTrigger]);

  return (
    <ConfirmationModal
      title='Cancel Email'
      isNegative
      body={
        <div>
          Are you sure you want to cancel the scheduled email to{' '}
          <strong>{candidateName}</strong>?
        </div>
      }
      isOpen={isOpen}
      confirmText='Close'
      cancelText='Cancel Email'
      onConfirm={handleCancellationConfirm}
      onCancel={onClose}
      size={'md'}
    />
  );
};
